import useServiceFactory from "../serviceFactory";

const apiUrl = `/administracion/liquidacionReporte`;

const useApiLiquidacionReporte = () => {
    const service = useServiceFactory({uri: process.env.REACT_APP_API_URL});
    return {
        filtrar: async (params) => service.get(`${apiUrl}`, {params, showLoading: true}),
        obtener: async (empleadoId,id) => service.get(`${apiUrl}/empleado/${empleadoId}/${id}`, {showLoading: true}),
        cancelarliquidacion: async (liquidacionId) => service.post(`${apiUrl}/cancelarliquidacion/${liquidacionId}`, {showSuccess:false}),
        excel: async (params) => service.get(`${apiUrl}/excel`,
            {
                params,
                showLoading: true,
                download: true,
                fileName: `LiquidacionesReporte.xlsx`
            }),
        excelconDetalle: async (params)=>service.get(`${apiUrl}/excelconDetalle`,
        {
                params,
                showLoading:true,
                download:true,
                fileName:`LiquidacionesReporteconDetalle.xlsx`
        }),
        excelOutsource: async (params) => {
            console.log("URL OUTSOURCE:", `${apiUrl}/excelOutsource`);

            return service.get(`${apiUrl}/excelOutsource`, {
                params,
                showLoading: true,
                download: true,
                fileName: `ReporteOutsource.xlsx`
            });
        },
        excelPreliquidacion: async (params) => {
            console.log("URL OUTSOURCE:", `${apiUrl}/excelPreliquidación`);

            return service.get(`${apiUrl}/excelPreliquidacion`, {
                params,
                showLoading: true,
                download: true,
                fileName: `ReportePreliquidacion.xlsx`
            });
        },
        obtenerEmpresaUsuario  : async (params) => service.get(`${"seguridad/usuarios/empresasPorUsuario"}`, {params}),
    }
};

export default useApiLiquidacionReporte;
